new Swiper("#sp-swiper1", {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
  },
  loop: true,
});
console.log(window.product)
function mainRender() {
  $(function () {
    $("#root").css("zoom", "normal");
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
          }, 100);
        };
      })()
    );
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
    config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    lazyLoadImages();

    // preloadImages(spImgList1);
    // preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") +
            -225 * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }

  $('.cart-btn').click(function(){
    let id = $(this).attr('data-id')
    window.location.href = '/cart/' + id + ':1'
  })
  
}

mainRender();
$(".option").click(function () {
  $(this).addClass("active").siblings().removeClass("active");
  let id = $(this).attr('data-id')
  let price = window.product.filter(item=> item.id == id)[0].price / 100
  let compare = window.product.filter(item=> item.id == id)[0].compare_at_price / 100
  price = ('€'+ price).replace('.', ',')
  compare = ('€'+ compare).replace('.', ',')
  $(this).parent().siblings('.price-group').find('.price1').html( price)
  $(this).parent().siblings('.price-group').find('.price2').html( compare)
  // let off_font = 100 - Math.ceil(price / compare * 100)
  // $(this).parent().parent().siblings('.sp-hot1').find('span').html(off_font)
});
$('.sp-btn-style').click(function(){
  let id = $(this).siblings('.opt-wrap').find('div.active').attr('data-id')
  window.location.href = '/cart/' + id + ':1'
})

// 购物车加购动效
$(".cart-btn").click(function () {
  $(this).children("img").addClass("on");
  $(".sp-header-top .sp-cart .num").show();
  setTimeout(function () {
    $(".cart-btn").children("img").removeClass("on");
  }, 500);
  $(".sp-header-top .sp-cart").addClass("on");
  setTimeout(function () {
    $(".sp-header-top .sp-cart").removeClass("on");
  }, 500);
});

let initNum = 0;
$(".product-part .cart-btn").click(function () {
  var img = $(this).parent().parent().find(".p-img");
  // var img = $(".product-part  .p-img");
  var flyer = img[0].cloneNode(true);
  flyer.classList.add("sp-clone");

  $("#shopping").append(flyer);
  $(".sp-clone").css({
    width: img[0].width,
    height: img[0].height,
    position: "fixed",
    top: img.offset().top - $(document).scrollTop(),
    // top: img[0].offsetTop,
    left: img.offset().left,
    "z-index": "99",
  });

  let finish = $(".sp-cart");
  $(".sp-clone").animate(
    {
      top: finish[0].offsetTop + $(".time-part").height(),
      left: finish[0].offsetLeft + finish.width() / 2,
      width: 50, // 结束时的大小，根据需要调整
      height: 50, // 结束时的大小，根据需要调整
      opacity: 0.4,
    },
    500,
    "linear",
    function () {
      $(this).animate(
        {
          width: 0,
          height: 0,
          opacity: 0,
        },
        0
      );
    }
  );
});
